<template>
  <div>
    <GlobalInfoBar title="门店列表" />
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalForm :form-item-list="formItemList" :inline="true" round @handleConfirm="query" confirmBtnName="查询">
        <div slot="AddSlot">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addOrEdit(null)">新增门店</el-button>
        </div>
      </GlobalForm>
      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="curPage"
        :total="totalElements" @handleCurrentChange="currentChange">
        <el-table-column label="剩余有效期" slot="surplus" align="center">
          <template slot-scope="{ row }">
            {{ row.surplus }}天
          </template>
        </el-table-column>
        <el-table-column label="门店数量" slot="num" align="center">
          <template slot-scope="{ row }">
            <div style="cursor: pointer;color: #0981FF;" @click="getShopList(row)"> {{ row.num }}</div>
            <el-button type="text" @click="expandStore(row)">扩店</el-button>
          </template>
        </el-table-column>
        <el-table-column label="员工数量" slot="staff_num" align="center">
          <template slot-scope="{ row }">
            <span style="cursor: pointer;color: #0981FF;" @click="getStaffList(row)"> {{ row.staff_num }}</span>

          </template>
        </el-table-column>
        <el-table-column label="店长邀请店员" slot="is_bring" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.is_bring" @change="staffSwitchChange(row)">
            </el-switch>

          </template>
        </el-table-column>
        <el-table-column label="启用禁用" slot="is_open" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.is_open" @change="switchChange(row)">
            </el-switch>

          </template>
        </el-table-column>
        <el-table-column label="操作" slot="operation" align="center" width="300">
          <template slot-scope="{ row }">
            <el-button type="text"
              @click="store_id = row.store_id, storeModeShow = true, write_mode = row.write_mode ? row.write_mode : []">
              核销方式配置</el-button>
            <el-button type="text" @click="addAccount(row)">
              分配后台账号</el-button>
            <el-button type="text" @click="addOrEdit(row)">编辑</el-button>
            <el-button type="text" @click="renewal(row)">续费</el-button>
            <el-button type="text" @click="renewLog(row)">续费记录</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>

    <el-dialog title="门店列表" :visible.sync="shopVisible" width="90%" :before-close="shopClose">
      <GlobalChunk :padding="[20, 20, 20, 20]">
        <GlobalForm :form-item-list="shopFormItemList" :inline="true" round @handleConfirm="shopQuery"
          confirmBtnName="查询" :initData="shopInitData">
        </GlobalForm>
        <GardenSlwct style="margin-bottom: 10px;" :tab-data="tabData" border-radius="40px" ref="garden"
          @tabAction="tabAction">
        </GardenSlwct>
        <GlobalTable ref="GlobalTable" :columns="shopColumns" :data="shopTableData" :currentPage="shopCurPage"
          :total="shopTotal" @handleCurrentChange="shopCurrentChange">
        </GlobalTable>
      </GlobalChunk>
    </el-dialog>

    <el-dialog title="员工列表" :visible.sync="staffVisible" width="90%" :before-close="staffClose">
      <GlobalChunk :padding="[20, 20, 20, 20]">
        <el-form :inline="true" :model="staffSearch" class="demo-form-inline">
          <el-form-item label="门店名称:">
            <el-select v-model="staffSearch.shop_id" placeholder="请选择门店" clearable>
              <el-option v-for="(item, index) of shopDropList" :key="index" :label="item.shop_name"
                :value="item.shop_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号:">
            <el-input v-model="staffSearch.phone" placeholder="请输入手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="姓名:">
            <el-input v-model="staffSearch.staff_name" placeholder="请输入姓名" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="staffQuery">查询</el-button>
            <el-button type="success" @click="staffDownload">导出Excel</el-button>

          </el-form-item>
        </el-form>
        <GardenSlwct style="margin-bottom: 10px;" :tab-data="tabData" :activeIndex="0" border-radius="40px"
          @tabAction="staffTabAction" ref="garden">
        </GardenSlwct>
        <GlobalTable ref="GlobalTable" :columns="staffColumns" :data="staffTableData" :currentPage="staffCurPage"
          :total="staffTotal" @handleCurrentChange="staffCurrentChange">
          <el-table-column label="姓名" slot="staff_name" align="center">
            <template slot-scope="{ row }">
              <el-tag style="margin-right: 5px;" :type="row.type == 0 ? 'danger' : (row.type == 1 ? '' : 'warning')"
                effect="dark">
                {{ row.type == 0 ? '创建人' : (row.type == 1 ? '店员' : '店长') }}
              </el-tag>
              <span>{{ row.staff_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" slot="operation" align="center" width="300">
            <template slot-scope="{ row }">
              <el-button type="danger" round @click="staffOperate(row, 1)">强制退登</el-button>
              <el-button type="warning" round @click="staffOperate(row, 2)">清除微信信息</el-button>
            </template>
          </el-table-column>
        </GlobalTable>
      </GlobalChunk>
    </el-dialog>

    <el-dialog title="续费记录" :visible.sync="renewVisible" width="90%" :before-close="renewClose">
      <GlobalChunk :padding="[20, 20, 20, 20]">
        <GlobalTable ref="GlobalTable" :columns="renewColumns" :data="renewTableData" :currentPage="renewCurPage"
          :total="renewTotal" @handleCurrentChange="renewCurrentChange">
          <el-table-column label="续费天数" slot="day" align="center">
            <template slot-scope="{ row }">
              {{ row.day }}天
            </template>
          </el-table-column>
          <el-table-column label="续费凭证" slot="evidence" align="center">
            <template slot-scope="{ row }">
              <img :src="row.evidence" alt="">
            </template>
          </el-table-column>
        </GlobalTable>
      </GlobalChunk>
    </el-dialog>

    <el-dialog title="分配账号" :visible.sync="accountVisible" width="35%" :before-close="accountClose">
      <span style="color: red;">开启门店商家管理后台，分配账号为门店端创建者。</span>
      <el-form style="margin-top: 15px;" :model="accountForm" :rules="accountRules" ref="accountForm"
        label-width="60px">

        <el-form-item label="账号" prop="account">
          <el-input v-model="accountForm.account"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input :disabled="true" show-password v-model="phone"></el-input>
          <span>初始密码默认为创建人手机号码，不可修改</span>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: end;">
          <el-button @click="accountClose">取消</el-button>
          <el-button type="primary" @click="submitAccount('accountForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="storeForm.store_id ? '编辑门店商' : '新增门店商'" :visible.sync="storeVisible" width="65%"
      :before-close="storeClose">
      <el-form :model="storeForm" :rules="storeRules" ref="storeForm" label-width="130px">
        <el-form-item label="门店商名称" prop="store_name">
          <el-input v-model="storeForm.store_name" placeholder="请输入门店商名称" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="门店商地址">
          <el-select @change="provinceHandleChange" v-model="storeForm.province_id" placeholder="请选择省" change>
            <el-option v-for="item in provinceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select @change="cityHandleChange" v-model="storeForm.city_id" placeholder="请选择市" style="margin: 0 5px;">
            <el-option v-for="item in cityOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="storeForm.district_id" placeholder="请选择区">
            <el-option v-for="item in distinguishOptions" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="storeForm.address" placeholder="请输入门详细地址" maxlength="80" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="director">
          <el-input v-model="storeForm.director" placeholder="请输入负责人" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="storeForm.phone" placeholder="请输入手机号" maxlength="11" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="开通门店数量" prop="num">
          <el-input-number v-model="storeForm.num" :precision="0" :min="0" label="请输入开通门店数量"></el-input-number>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: end;">
          <el-button @click="storeClose">取消</el-button>
          <el-button type="primary" @click="submitStore('storeForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="续费" :visible.sync="renewalVisible" width="35%" :before-close="renewalClose">
      <span>续费门店商：{{ renewalForm.store_name }}</span>
      <div style="display: flex;justify-content: space-around;margin: 15px;">
        <div>
          <div>续费前</div>
          <div>到期时间：{{ (renewalForm.exp_date || '').substring(0, 10) }}</div>
          <div>剩余有效期：{{ renewalForm.surplus }}天</div>
        </div>
        <div style="border-left: 1px solid black; height: 60px;"></div>
        <div>
          <div>续费后</div>
          <div>到期时间：{{ renewalForm.after_date }}</div>
          <div>剩余有效期：{{ dateDiffInDays }}天</div>
        </div>
      </div>
      <el-form :model="renewalForm" :rules="renewalRules" ref="renewalForm" label-width="110px">
        <el-form-item label="续费金额" prop="amount">
          <el-input-number v-model="renewalForm.amount" :precision="2" :step="0.01" :min="0" :max="9999"
            label="请输入大于0的数，可保留小数点后2位"></el-input-number>
        </el-form-item>
        <el-form-item label="服务到期时间" prop="after_date">
          <el-date-picker :picker-options="pickerOptions" @change="handleDateChange" v-model="renewalForm.after_date"
            type="datetime" placeholder="选择日期时间" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="续费凭证" :key="evidence" prop="evidence">
          <el-upload v-if="!renewalForm.evidence" action="#" list-type="text" multiple drag :limit="1" show-file-list
            :auto-upload="false" :on-change="(file) => { getFile(file, 'renewal') }">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
          <div v-else class="row-img-wrapper">
            <img :src="evidence" alt="" width="300px">
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="renewalForm.remarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="50"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: end;">
          <el-button @click="renewalClose">取消</el-button>
          <el-button type="primary" @click="submitRenewal('renewalForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="操作确认" :visible.sync="yesRenewalVisible" width="30%">
      <div style="display: flex;justify-content: space-around;margin: 15px;">
        <div>
          <div>续费前</div>
          <div>到期时间：{{ (renewalForm.exp_date || '').substring(0, 10) }}</div>
          <div>剩余有效期：{{ renewalForm.surplus }}天</div>
        </div>
        <div style="border-left: 1px solid black; height: 60px;"></div>

        <div>
          <div>续费后</div>
          <div>到期时间：{{ renewalForm.after_date }}</div>
          <div>剩余有效期：{{ dateDiffInDays }}天</div>
        </div>
      </div>
      <span>是否确认为门店续费？</span>
      <div style="display: flex;justify-content: end;padding: 30px;">
        <el-button @click="yesRenewalVisible = false">取消</el-button>
        <el-button type="primary" @click="yesRenewal()">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="扩店" :visible.sync="expandStoreVisible" width="600px" :before-close="expandStoreClose">
      <el-form :model="expandStoreForm" :rules="expandStoreRules" ref="expandStoreForm" label-width="110px">
        <el-form-item label="扩店门店商：">
          <span>{{ expandStoreForm.store_name }}</span>
        </el-form-item>
        <el-form-item label="当前门店数量：">
          <span>{{ expandStoreForm.num }}</span>
        </el-form-item>
        <el-form-item label="新增门店数" prop="new_num">
          <el-input-number style="margin-right: 5px;" v-model="expandStoreForm.new_num" :min="0" :precision="0"
            label="描述文字"></el-input-number>
          <span>个</span>
        </el-form-item>
        <el-form-item label="扩店凭证" :key="evidence" prop="evidence">
          <el-upload v-if="!expandStoreForm.evidence" action="#" list-type="text" multiple drag :limit="1"
            show-file-list :auto-upload="false" :on-change="(file) => { getFile(file, 'expandStore') }">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
          <div v-else class="row-img-wrapper">
            <img :src="evidence" alt="" width="300px">
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="expandStoreForm.remarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: end;">
          <el-button @click="expandStoreClose">取消</el-button>
          <el-button type="primary" @click="submitExpandStore()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="操作确认" :visible.sync="yesExpandStoreVisible" width="30%">
      <div style="display: flex;justify-content: space-around;margin: 15px;">
        <div>
          <div>扩店前</div>
          <div>门店数量：{{ expandStoreForm.num }}</div>
        </div>
        <div style="border-left: 1px solid black; height: 60px;"></div>

        <div>
          <div>扩店后</div>
          <div>门店数量：{{ expandStoreForm.num + expandStoreForm.new_num }}</div>
        </div>
      </div>
      <span>是否确认扩店？</span>
      <div style="display: flex;justify-content: end;padding: 30px;">
        <el-button @click="yesExpandStoreVisible = false">取消</el-button>
        <el-button type="primary" @click="yesExpandStore()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="核销方式配置" :visible.sync="storeModeShow" width="30%">
      <div style="font-weight: 900;font-size: 15px;margin: 10px 0;">
        请选择核销方式配置：
      </div>
      <el-checkbox-group v-model="write_mode">
        <el-checkbox label="扫码核销"></el-checkbox>
        <el-checkbox label="手机号核销"></el-checkbox>
      </el-checkbox-group>
      <div style="display: flex;justify-content: end;padding: 15px;">
        <el-button @click="storeModeShow = false">取消</el-button>
        <el-button type="primary" @click="writeModeSubmit()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  storeList, shopList, shopDrop, storeRenewLog, staffList, staffOperate, tableDownload, openOperate,
  storeAccount, getRegion, storeSet, imageUp, storeRenew, storeExtend, storeMode
} from "@/utils/request/membershipSystem";
import GardenSlwct from "./components/gardenSlwct.vue";

export default {
  name: "storeList",
  components: {
    GardenSlwct,
  },
  data() {
    return {
      storeId: null,
      formItemList: [{
        key: 'store_name',
        type: 'input',
        labelName: '门店名称:',
        placeholder: '请输入门店名称'
      }, {
        key: 'director',
        type: 'input',
        labelName: '联系人:',
        placeholder: '请输联系人'
      }, {
        key: 'phone',
        type: 'input',
        labelName: '负责人联系方式:',
        placeholder: '请输入负责人联系方式'
      },
      {
        key: 'origin',
        idKey: 'id',
        labelKey: 'name',
        type: 'selectFilterable',
        labelName: '门店商来源:',
        option: [{
          id: null,
          name: "全部"
        }, {
          id: '1',
          name: "门店后台"
        }, {
          id: '2',
          name: "小程序"
        }],
        placeholder: '请选择门店商来源'
      },
      ],
      searchData: {},
      tableColumns: [
        { label: "门店商来源", prop: "origin_title" },
        { label: "门店商名称", prop: "store_name" },
        { label: "门店商地址", prop: "address" },
        { label: "联系人/创建人", prop: "director" },
        { label: "手机号", prop: "phone" },
        { label: "支付总金额", prop: "total_amount" },
        { label: "到期时间", prop: "exp_date" },
        { slotName: "surplus" },
        { label: "续费时间", prop: "renewal_time" },
        { slotName: "num" },
        { slotName: "staff_num" },
        { slotName: "is_bring" },
        { slotName: "is_open" },
        { slotName: "operation" },
      ],
      tableData: [],
      curPage: 1,
      totalElements: 0,
      shopVisible: false,
      tabData: [{
        text: "已启用",
        value: 1,
        num: 0,

      },
      {
        text: "已禁用",
        value: 0,
        num: 0,

      }, {
        text: "已删除",
        value: 2,
        num: 0,

      },],
      shopFormItemList: [{
        key: 'shop_id',
        idKey: 'shop_id',
        labelKey: 'shop_name',
        type: 'selectFilterable',
        labelName: '门店名称:',
        option: [],
        placeholder: '请选择门店'
      }, {
        key: 'phone',
        type: 'input',
        labelName: '店长手机号:',
        placeholder: '请输入店长手机号'
      }, {
        key: 'director',
        type: 'input',
        labelName: '店长姓名:',
        placeholder: '请输入店长姓名'
      },],
      shopInitData: {},
      shopColumns: [
        { label: "门店名称", prop: "shop_name" },
        { label: "门店地址", prop: "address" },
        { label: "店长姓名", prop: "director" },
        { label: "店长联系方式", prop: "phone" },
        { label: "店员数量", prop: "staff_num" },
        { label: "添加时间", prop: "add_time" },
      ],
      shopTableData: [],
      shopCurPage: 1,
      shopTotal: 0,
      shopSearch: {},
      staffVisible: false,
      shopDropList: [],
      staffColumns: [
        { slotName: "staff_name" },
        { label: "手机号", prop: "phone" },
        { label: "注册时问", prop: "add_time" },
        { label: "所属/管理门店", prop: "shop_name" },
        { label: "最近登录时问", prop: "login_time" },
        { slotName: "operation" },

      ],
      staffTableData: [],
      staffCurPage: 1,
      staffTotal: 0,
      staffSearch: {},
      renewVisible: false,
      renewColumns: [
        { label: "续费时间", prop: "add_time" },
        { label: "续费金额", prop: "amount" },
        { label: "续费前到期时间", prop: "front_date" },
        { label: "续费后到期时间", prop: "after_date" },
        { slotName: "day" },
        { label: "续费操作人", prop: "user_name" },
        { slotName: "evidence" },
        { label: "备注", prop: "remarks" },
      ],
      renewTableData: [],
      renewCurPage: 1,
      renewTotal: 0,
      accountVisible: false,
      accountForm: { account: '' },
      accountRules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9]{6,10}$/,
            message: '必须由6-10个字母或数字组成',
            trigger: 'blur'
          }
        ]
      },
      phone: '',
      storeVisible: false,
      storeForm: {},
      storeRules: {
        store_name: [
          { required: true, message: '请输入门店商名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        director: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '请输入开通门店数量', trigger: 'blur' }
        ]
      },
      provinceOptions: [],
      cityOptions: [],
      distinguishOptions: [],
      renewalVisible: false,
      renewalRules: {
        amount: [
          { required: true, message: '请输入续费金额', trigger: 'blur' }
        ],
        after_date: [
          { required: true, message: '请选择服务到期时间', trigger: 'blur' }
        ],
        evidence: [
          { required: true, message: '请上传缴费凭证', trigger: 'blur' }
        ],
      },
      renewalForm: {
        store_name: '', // 门店名称
        add_time: '', // 添加时间
        after_date: '', // 续费后到期时间
        surplus: 0, // 剩余有效期
        amount: 0 // 续费金额
      },
      pickerOptions: {
        disabledDate: (date) => {
          if (!this.renewalForm || !this.renewalForm.amount) return false;
          const limitDate = new Date(this.renewalForm.amount);
          return date < limitDate;
        }
      },
      evidence: '',
      yesRenewalVisible: false,
      expandStoreVisible: false,
      expandStoreForm: {},
      expandStoreRules: {
        new_num: [
          { required: true, message: '请输入新增门店数', trigger: 'blur' }
        ],
        evidence: [
          { required: true, message: '请上传扩店凭证', trigger: 'blur' }
        ],
      },
      yesExpandStoreVisible: false,
      storeModeShow: false,
      store_id: '',
      write_mode: []
    }
  },
  computed: {
    dateDiffInDays() {
      console.log('renewalForm', this.renewalForm);
      // const { surplus, after_date, exp_date } = this.renewalForm
      // if (!this.renewalForm || !this.renewalForm.surplus == 0 || !this.renewalForm.after_date) return 0;

      // let d1
      // let d2
      //   //当天开始续费
      // if (surplus == 0) {
      //   d1 = new Date();
      //   d2 = new Date(after_date);
      // } else {
      //   //到期日期开始续费
      //   d1 = new Date(exp_date);
      //   d2 = new Date(after_date);
      // }


      // const date1 = this.renewalForm.add_time.substring(0, 10);
      // const date2 = this.renewalForm.after_date;
      // const d1 = new Date(date1);
      // const d2 = new Date(date2);

      const d1 = new Date();
      const d2 = new Date(this.renewalForm.after_date);
      const timeDiff = Math.abs(d2.getTime() - d1.getTime());
      return timeDiff ? Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) : '';
    }
  },
  watch: {
    'storeForm.province_id': { // 监听 obj.key 的变化
      handler(newVal, oldVal) {
        console.log('obj.province_id 变化:', oldVal, '→', newVal);
        if (oldVal) {
          this.storeForm.city_id = null
          this.cityOptions = []
          this.storeForm.district_id = null
          this.distinguishOptions = []
        }
      },

    },
    'storeForm.city_id': { // 监听 obj.key 的变化
      handler(newVal, oldVal) {
        console.log('obj.city_id 变化:', oldVal, '→', newVal);
        if (oldVal) {
          this.storeForm.district_id = null
          this.distinguishOptions = []

        }
      },

    }
  },

  mounted() {
    this.storeList()
  },

  methods: {
    writeModeSubmit() {
      console.log('write_mode', this.write_mode);
      storeMode({ store_id: this.store_id, write_mode: this.write_mode }).then(res => {
        this.storeModeShow = false
        this.storeList()
        this.$message.success(res.msg)
      })
    },
    storeList() {
      storeList({
        page: this.curPage,
        ...this.searchData
      }).then(res => {
        res.data.map((ele) => {
          ele.is_open = ele.is_open == 1 ? true : false
          ele.is_bring = ele.is_bring == 1 ? true : false
        })
        this.tableData = res.data || []
        this.totalElements = res.count || 0
      })
    },
    currentChange(page) {
      this.curPage = page
      this.storeList()
    },
    query(data, cd) {
      this.searchData = data
      this.curPage = 1
      this.storeList()
    },
    staffSwitchChange(row) {
      console.log(row);
      const { store_id, is_bring } = row
      this.$alert(`是否确认${is_bring ? '开启' : '禁用'}？`, '确认弹窗', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            openOperate({
              type: '3',
              val: is_bring ? 1 : 0,
              id: store_id
            }).then(res => {
              this.$message.success(res.msg)
              this.reset()
            })
          } else {
            row.is_bring = !is_bring
          }
        }
      });

    },
    switchChange(row) {
      console.log(row);
      const { store_id, is_open } = row
      this.$alert(`是否确认${is_open ? '开启' : '禁用'}？`, '确认弹窗', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            openOperate({
              type: '2',
              val: is_open ? 1 : 0,
              id: store_id
            }).then(res => {
              this.$message.success(res.msg)
              this.reset()
            })
          } else {
            row.is_open = !is_open
          }
        }
      });

    },
    addOrEdit(row) {
      getRegion().then(res => {
        this.provinceOptions = res.data
      });
      if (row) {
        this.storeForm = row;
        const { province_id, city_id } = row
        getRegion({
          pid: province_id
        }).then(res => {
          this.cityOptions = res.data
        });
        getRegion({
          pid: city_id
        }).then(res => {
          this.distinguishOptions = res.data
        });
      }
      this.storeVisible = true;
    },
    provinceHandleChange(value) {
      // this.distinguishOptions = []
      // this.cityOptions = []
      // this.storeForm.city_id = null
      // this.storeForm.district_id = null
      getRegion({
        pid: value
      }).then(res => {
        this.cityOptions = res.data
      });
    },
    cityHandleChange(value) {
      getRegion({
        pid: value
      }).then(res => {
        this.distinguishOptions = res.data
      });
    },
    submitStore(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { store_id, store_name, province_id, city_id, district_id, address, director, phone, num } = this.storeForm

          this.$alert(`${store_id ? '是否确认编辑门店？' : '是否确认新增门店？'}`, '操作确认', {
            confirmButtonText: '确定',
            callback: action => {
              if (action == 'confirm') {
                storeSet({ store_id, store_name, province_id, city_id, district_id, address, director, phone, num }).then(res => {
                  this.$message({
                    message: '操作成功',
                    type: 'success'
                  });
                  this.storeVisible = false
                  this.$refs['storeForm'].resetFields();
                  this.storeForm = {}
                  this.reset()

                })
              }
            }
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    storeClose() {
      this.storeVisible = false
      this.$refs['storeForm'].resetFields();
      this.storeForm = {}
      this.cityOptions = []
      this.distinguishOptions = []
      this.reset()
    },
    //门店
    getShopList(row) {
      const { store_id } = row
      this.storeId = store_id
      this.shopVisible = true
      shopDrop({
        store_id
      }).then(res => {
        this.shopFormItemList[0].option = res.data || []
      })
      this.shopList()
    },
    shopList() {
      shopList({
        page: this.shopCurPage,
        store_id: this.storeId,
        ...this.shopSearch
      }).then(res => {
        this.shopTableData = res.data || []
        this.shopTotal = res.count || 0
      })
    },
    shopQuery(data) {
      console.log('data', data);
      this.shopSearch = data
      this.shopList()
    },
    tabAction(v) {
      console.log(v);
      this.shopSearch.is_open = v == 0 ? 1 : (v == 1 ? 0 : 2)
      this.shopList()
    },
    shopCurrentChange(page) {
      this.shopCurPage = page
      this.shopList()
    },
    shopClose() {
      this.shopVisible = false
      this.$refs.garden.reset();

      this.reset()
    },

    //员工
    getStaffList(row) {
      const { store_id } = row
      this.storeId = store_id
      this.staffVisible = true
      shopDrop({
        store_id
      }).then(res => {
        this.shopDropList = res.data || []
      })
      this.staffList()
    },
    staffList() {
      staffList({
        page: this.staffCurPage,
        store_id: this.storeId,
        ...this.staffSearch
      }).then(res => {
        this.staffTableData = res.data || []
        this.staffTotal = res.count || 0
      })
    },
    staffQuery() {
      this.staffList()
    },
    staffTabAction(v) {
      console.log(v);
      this.staffSearch.is_open = v == 0 ? 1 : (v == 1 ? 0 : 2)
      this.staffList()
    },
    staffOperate(row, type) {
      const { staff_id } = row
      staffOperate({
        staff_id,
        type
      }).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.staffList()

      })
      console.log(type);

    },
    staffCurrentChange(page) {
      this.staffCurPage = page
      this.staffList()
    },
    staffDownload() {
      tableDownload({
        store_id: this.storeId,
        ...this.staffSearch
      }).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        const fileName = "员工列表.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    staffClose() {
      this.staffVisible = false
      this.$refs.garden.reset();

      this.reset()

    },
    //续费
    renewal(row) {
      this.renewalForm = { ...row }; // 确保 renewalForm 已赋值
      this.renewalVisible = true;
    },
    disabledDate(date) {
      const limitDate = new Date('2025-03-13');
      return date < limitDate;
    },

    handleDateChange(date) {
      this.renewalForm.after_date = date
    },
    getFile(file, type) {
      let formData = new FormData();
      formData.append('file', file.raw)
      imageUp(formData).then(res => {
        console.log(111);
        if (type == 'renewal') {
          this.renewalForm.evidence = res.data.url

        } else {
          this.expandStoreForm.evidence = res.data.url

        }
        this.evidence = res.data.url

      })
    },
    submitRenewal(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.yesRenewalVisible = true
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    yesRenewal() {
      const { amount, after_date, evidence, remarks, store_id } = this.renewalForm
      storeRenew({
        amount, after_date, evidence, remarks, store_id
      }).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.renewalVisible = false
        this.yesRenewalVisible = false
        this.reset()
        this.$refs['renewalForm'].resetFields();
      })
    },
    renewalClose() {
      this.renewalVisible = false
      this.$refs['renewalForm'].resetFields();
      this.reset()
    },
    //缴费的列表
    renewLog(row) {
      this.renewVisible = true
      const { store_id } = row
      this.storeId = store_id
      storeRenewLog({
        page: this.renewCurPage,
        store_id: this.storeId,
      }).then(res => {
        this.renewTableData = res.data || []
        this.renewTotal = res.count || 0
      })
    },
    renewCurrentChange(page) {
      this.renewCurPage = page
      this.renewLog()
    },
    renewClose() {
      this.renewVisible = false
      this.reset()
    },
    //分配后台账号
    addAccount(row) {
      const { store_id, phone, account } = row
      console.log(row, 'addAccount');
      this.accountForm.account = account
      this.storeId = store_id
      this.phone = phone
      this.accountVisible = true

    },
    submitAccount(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          storeAccount({
            store_id: this.storeId,
            ...this.accountForm
          }).then(res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.accountVisible = false
            this.$refs['accountForm'].resetFields();
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    accountClose() {
      this.accountVisible = false
      this.$refs['accountForm'].resetFields();
      this.reset()
    },

    // 扩店
    expandStore(row) {
      console.log(row);
      this.expandStoreForm = row
      this.expandStoreVisible = true

    },
    expandStoreClose() {
      this.expandStoreVisible = false
      this.$refs['expandStoreForm'].resetFields();
      this.reset()

    },
    submitExpandStore() {
      this.$refs['expandStoreForm'].validate((valid) => {
        if (valid) {
          console.log(111);
          this.yesExpandStoreVisible = true
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    yesExpandStore() {
      console.log('this.expandStoreForm', this.expandStoreForm);
      const { store_id, new_num, evidence, remarks } = this.expandStoreForm
      storeExtend({ store_id, new_num, evidence, remarks }).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.yesExpandStoreVisible = false
        this.expandStoreVisible = false
        this.$refs['expandStoreForm'].resetFields();
        this.reset()

      })
    },
    //重置
    reset() {
      this.shopInitData = {}
      this.staffSearch = {}
      this.evidence = ''
      this.curPage = 1
      this.storeList()
    },
  }
}
</script>

<style scoped lang="scss"></style>
